export default "__VITE_ASSET__RWGFL0xv__"